import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../helpers/browserStorage";
import Header from "./Header";
import { useMutation } from "react-query";
import useUser from "../hooks/pages/useUser";
import { usePopup } from "../contexts/PopupContext";
import usePages from "../hooks/pages/usePages";
import Sidebar from "./Sidebar";
import { useApp } from "../contexts/AppContext";

function MainLayout() {
  const navigate = useNavigate();
  const { setIsOwner, pageId, setPageId, pages, setPages } = useApp();

  const { toast } = usePopup();

  const { getOrgPermission } = useUser();

  const { getPages } = usePages();

  const { mutate: getPagesMutate } = useMutation({
    mutationFn: getPages,
    onSuccess: (res) => {
      const { pages } = res?.data || {};

      setPages(pages);

      if (!pages?.length) {
        removeLocalStorage("pageId");
        navigate("/pages");
        return;
      }

      const page = pages.find((page) => page._id === pageId);

      if (!page && pages?.length) {
        const selectedPageId = pages[0]._id;

        setLocalStorage("pageId", selectedPageId);
        setPageId(selectedPageId);
      }
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting pages!";
      toast(message, "error");
    },
  });

  const { mutate: orgPermissionMutate } = useMutation({
    mutationFn: getOrgPermission,
    onSuccess: (res) => {
      const { isOwner } = res?.data || {};
      setIsOwner(isOwner);
      getPagesMutate();
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting organization permission!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    const organizationId = getLocalStorage("organizationId");

    if (!organizationId) {
      navigate("/organization");
    } else {
      orgPermissionMutate(organizationId);
    }
  }, []);

  return (
    <div>
      <Header />

      <div className="content-padding-top">
        <Sidebar pages={pages} refetchPages={getPagesMutate} />
      </div>

      <div className="children-position pl-8 pr-4 pt-6">
        <Outlet />
      </div>
    </div>
  );
}

export default MainLayout;
